import heroBgField from '../fields/heroBgField';

export default {
  value: 'image_full',
  label: 'Image full',
  fields: [heroBgField]
};
